import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Alert } from '@c2fo/liquidity';
import { useOfferBuilderContext } from '../OfferBuilderContext';
import { useRateCalculations } from '../useRateCalculations';

const ExistingOfferNotification = () => {
  const { t } = useTranslation();
  const {
    state: { selected },
  } = useOfferBuilderContext();
  const { getRateComparison } = useRateCalculations();

  const takerMarketsWithExistingOffers = useMemo(() => {
    return selected.filter((takerMarket) => {
      // Must have an existing offer
      if (!takerMarket.offerConfig?.uuid) {
        return false;
      }

      // Check if the working rate is different than the current config rate
      const { hasRateChanged } = getRateComparison(takerMarket);
      return hasRateChanged;
    });
  }, [selected, getRateComparison]);

  return takerMarketsWithExistingOffers.length > 0 ? (
    <Alert description={t('builder.existingOfferMessage')} full type="info" />
  ) : null;
};

export default ExistingOfferNotification;
